export const templateData=[
    { userName: 'sampleuser', email: 'sampleuser@example.com' },
    { userName: 'johndoe', email: 'johndoe@example.com' }
]